import { createContext, useContext } from 'react';

export const DesktopAlertContext = createContext(null);

export const useDesktopAlert = () => {
  const context = useContext(DesktopAlertContext);

  if (!context) {
    throw new Error('useDesktopAlert must be used within a DesktopAlertProvider');
  }

  return context;
};
